import type { SortKey, SortRule } from "../../shared/sorting";

export default function SortableHeader({
  label,
  sortKey,
  current,
  onSort,
  numeric,
  className,
}: {
  label: string;
  sortKey: SortKey;
  current: SortRule;
  onSort: (key: SortKey) => void;
  numeric?: boolean;
  className?: string;
}) {
  const active = current.key === sortKey;
  const ariaSort: "ascending" | "descending" | "none" = active
    ? current.direction === "asc"
      ? "ascending"
      : "descending"
    : "none";
  const arrow = active ? (current.direction === "asc" ? "▲" : "▼") : "";

  return (
    <th
      aria-sort={ariaSort}
      className={[numeric ? "numeric" : "", className ?? ""].join(" ").trim()}
    >
      <button type="button" onClick={() => onSort(sortKey)}>
        {label}
        <span aria-hidden="true" className="sortable-arrow">
          {arrow}
        </span>
      </button>
    </th>
  );
}
